export default {
  default: {
    built: 'Built With',
  },
}
